import { createSlice } from "@reduxjs/toolkit";
import {
  filterRoutesCompleted,
  filterRoutesDontPublics,
  filterRoutesPublics,
  formatDuration,
  truncarDecimales,
} from "../actions/routeActions";

// Estado inicial
const initialState = {
  route: {
    id: "",
    nameRoute: "",
    description: "",
    distance: 0,
    estimatedTime: "0 min",
    difficulty: "",
    terrainType: "",
    coordinates: [], //full coordenadas de la ruta
    landMarks: [], //Puntos de referencia para la ruta
    isPublic: false,
    trainingInstructions: [],
  },
  listRoutes: [], //Lista de rutas guardadas
  listRoutesDontPublics: [],
  listRoutesPublicsOfUser: [],
  listRoutesCompleted: [],
  listRoutesAssigned: [],
  loactionInstruction: [],
  directions: [],
  statusRoute: false, //Indica si la ruta ha sido guardada en BD
  drawRoute: false, //Indica si se esta o no dibujando la ruta
  saveRoute: false, //Indica el status si se abre o no modal de guardar
  initRoute: false, //Indica si se inicia la ruta o no
  getRoute: false, //Indica si se obtiene la ruta o no
  kmCompleted: 0,
  routesCompleted: 0,
  totalOfRoutes: 0,
};

// Slice de ruta
const routeSlice = createSlice({
  name: "route",
  initialState,
  reducers: {
    setlistRoutes: (state, action) => {
      state.listRoutes = action.payload.listRoutes;
      state.listRoutesDontPublics = filterRoutesDontPublics(
        action.payload.listRoutes
      );
      state.listRoutesPublicsOfUser = filterRoutesPublics(
        action.payload.listRoutes
      );
      state.totalOfRoutes = action.payload?.totalOfRoutesMembership ?? 0;
      state.listRoutesCompleted = filterRoutesCompleted(
        action.payload?.listRoutes
      );
    },
    setListRoutesAssigned: (state, action) => {
      state.listRoutesAssigned = action.payload.listRoutesAssigned;
    },
    setDataRoute: (state, action) => {
      state.route.distance = action.payload.distance;
      state.route.estimatedTime = formatDuration(action.payload.estimatedTime);
    },
    setInfoRoute: (state, action) => {
      state.route.nameRoute = action.payload.nameRoute;
      state.route.description = action.payload.description;
      state.route.difficulty = action.payload.difficulty;
      state.route.terrainType = action.payload.terrainType;
      state.route.isPublic = action.payload.isPublic;
      state.statusRoute = true;
    },
    setTrainingInstructions: (state, action) => {
      state.route.trainingInstructions.push(action.payload.instruction);
    },
    setLocationInstruction: (state, action) => {
      state.loactionInstruction = action.payload.loactionInstruction;
    },
    setCoordinates: (state, action) => {
      state.route.coordinates = action.payload.coordinates;
    },
    setLandMarks: (state, action) => {
      state.route.landMarks = action.payload.landMarks;
    },
    setDrawRoute: (state) => {
      state.drawRoute = !state.drawRoute;
    },
    setSaveRoute: (state, action) => {
      state.route.id = action.payload.id;
      state.saveRoute = true;
    },
    dontSaveRoute: (state) => {
      state.route.id = "";
      state.saveRoute = false;
    },
    setSatusRoute: (state) => {
      state.statusRoute = !state.statusRoute;
    },
    clearCoordinates: (state) => {
      state.route.coordinates = [];
      state.route.distance = 0;
      state.route.estimatedTime = "";
      state.route.landMarks = [];
    },
    setInitRoute: (state, action) => {
      state.initRoute = action.payload.initRoute;
    },
    setGetRoute: (state, action) => {
      state.getRoute = action.payload.getRoute;
    },
    setDirections: (state, action) => {
      state.directions = action.payload.directions;
    },
    sportsPerformance: (state, action) => {
      state.kmCompleted = truncarDecimales(action.payload.kmCompleted, 2);
      state.routesCompleted = action.payload.routesCompleted;
    },
    clearRoute: (state) => {
      state.route.id = "";
      state.route.nameRoute = "";
      state.route.description = "";
      state.route.distance = 0;
      state.route.estimatedTime = "0 min";
      state.route.terrainType = "";
      state.route.coordinates = [];
      state.route.landMarks = [];
      state.route.difficulty = "";
      state.route.terrainType = "";
      state.route.isPublic = false;
      state.drawRoute = false;
      state.statusRoute = false;
      state.initRoute = false;
      state.saveRoute = false;
      state.directions = [];
      state.getRoute = false;
      state.route.trainingInstructions = [];
      state.listRoutes = [];
      state.listRoutesCompleted = [];
      state.listRoutesAssigned = [];
    },
  },
});

export const {
  setDataRoute,
  setInfoRoute,
  setCoordinates,
  setLandMarks,
  setDrawRoute,
  setIncidentsReports,
  setSaveRoute,
  dontSaveRoute,
  setInitRoute,
  setGetRoute,
  clearCoordinates,
  clearRoute,
  setDirections,
  setTrainingInstructions,
  setLocationInstruction,
  setSatusRoute,
  setlistRoutes,
  sportsPerformance,
  setListRoutesAssigned,
} = routeSlice.actions;
export default routeSlice.reducer;
